import React from "react";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import {phpToMomentDateFormat, truncateToLastWord} from "../../../ts/common/SiteHelper";
import {wbsp} from "../../../ts/common/Constants";
import moment from "moment/moment";
import AppButton from "../../element/button/AppButton";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import {getManager} from "../../../ts/manager/Manager";
import {PostType} from "../../../ts/manager/post/PostManager";

interface IProps
{
    routeChoice: RouteChoice;
    extraClass?:string
    noImage?:boolean
    cardNumber?:number
    cardTotal?:number
}

const CardView = (props: IProps) =>
{
    const routeChoice = props.routeChoice;
    const postDataChoice = routeChoice.postDataChoice;
    const organisationChoice = postDataChoice?.getParentChoice() ?? null;
    const cardTotal = props.cardTotal ?? 0;
    const cardNumber = cardTotal > 0 ? (props.cardNumber ?? -1) : -1;
    const cardName = postDataChoice?.name ?? routeChoice.name;
    const isMyProfileRoute = getManager().navigation.model.routeIDs.browse_route_id === "my_profile";
    return <div className={"card h-100 with-link " + (props.extraClass ?? "")}>

        <div className="card-body">

            <div className="row">
                <div className="col-12">
            {cardNumber > 0 && <>
                <p className="text-end">{cardNumber}/{cardTotal}</p>
            </>}

            <h2 className="card-title">
                {cardName.length > 100 ? cardName.substring(0, 120)  + '...' : cardName}
            </h2>

            {(!!postDataChoice?.thumbnail && !props.noImage) ? <>
                <div
                    className="card-img-right"
                    style={{
                        backgroundImage: "url(" + postDataChoice.thumbnail.size.small_square.url +")",
                    }}
                >
                    <span className="visually-hidden">
                        {"Image of " + postDataChoice.name}
                    </span>
                </div>
            </> : <></>}

            {((postDataChoice?.postStatus ?? "publish") !== "publish") ? <>
                <p className={"post-status-"+postDataChoice!.postStatus}>{getManager().post.postStatusNames[postDataChoice!.postStatus]}</p>
            </> : <></>}

            {!!postDataChoice?.description ? <>
                <p className="">{truncateToLastWord(postDataChoice.description)}</p>
            </> : <></>}

            {((postDataChoice?.postType === "project") || (postDataChoice?.postType === "career") || (postDataChoice?.postType === "offer")) ? <>

                <ul className="project-details">

                    {!!organisationChoice && <>
                        <li className="who"><strong>Published by:</strong>{wbsp}{organisationChoice.name ?? ""}</li>
                    </>}
                    <li className="where"><strong>Location:</strong>{wbsp}{postDataChoice.addressVO.quickLocation()}
                    </li>
                    <li className="what"><strong>Categories:</strong>{wbsp}{postDataChoice.categoriesListed}</li>
                    {!!postDataChoice?.endsAt && <>
                        <li className="when">
                            <strong>{postDataChoice.postType !== "career" ? "Available until" : "Closes"}:</strong>
                            {wbsp}{moment(postDataChoice.endsAt).format(phpToMomentDateFormat('jS F Y'))}
                        </li>
                    </>}

                </ul>
            </> : <></>}
                </div>
            </div>
            {(!!postDataChoice && (postDataChoice?.postType !== "page")) && <>
                <div className="row">
                    <div className="col-12">
                    <p className="text-end mb-0 pb-0">
                            <AppButton className="outline reduced mt-3 mb-0 with-icon">{!isMyProfileRoute ? "Learn More" : ((["project", "offer"] as (PostType|"")[]).includes(postDataChoice?.postType ?? "") ? "Edit" : "View")}</AppButton>
                        </p>
                    </div>
                </div>
            </>}


        </div>

        <RouteChoiceButton
            className="stretched-link"
            routeChoice={routeChoice}
            label=""
        />

    </div>
}
export default CardView;